export default __webpack_public_path__ + "static/media/tischlereirubisch_1.26eb676c.jpg";